import lrz from './lrz';

const slice = Array.prototype.slice;

// 创建文件输入元素，但不立即添加到DOM
const createInputElement = () => {
  const inputEl = document.createElement('input');
  inputEl.type = 'file';
  inputEl.accept = 'image/*';
  inputEl.multiple = true;
  inputEl.style.display = 'none';
  inputEl.style.position = 'absolute';
  inputEl.style.left = '-9999px';
  inputEl.style.top = '-9999px';
  return inputEl;
};

// 全局输入元素引用
let globalInputEl: HTMLInputElement | null = null;

// 获取或创建输入元素
const getInputElement = () => {
  if (!globalInputEl || !document.body.contains(globalInputEl)) {
    // 如果元素不存在或已从DOM中移除，创建新的
    globalInputEl = createInputElement();
    document.body.appendChild(globalInputEl);
    console.log('123 chooseImageFn append input');
  }
  return globalInputEl;
};

/**
 *
 * @param {number} maxWidth 最大宽度
 * @param {number} maxHeight 最大高度
 * @param {number} quality 图片质量, 0 - 100
 * @param {number} count 图片数量
 * @returns {Promise<Object>}
 */
function chooseImage({
  maxWidth,
  maxHeight,
  quality,
  count = 1,
}) {
  quality /= 100;
  const inputEl = getInputElement(); // 获取或创建input元素
  inputEl.value = '';
  console.log('123 chooseImageFn input start');
  return new Promise((resolve, reject) => {
    let isResolved = false;
    let cancelTimer: number | null = null;
    let timeoutTimer: number | null = null;

    // 清理函数
    const cleanup = () => {
      if (cancelTimer) {
        clearTimeout(cancelTimer);
        cancelTimer = null;
      }
      if (timeoutTimer) {
        clearTimeout(timeoutTimer);
        timeoutTimer = null;
      }
      // 移除事件监听器
      window.removeEventListener('focus', handleWindowFocus);
      document.removeEventListener('keydown', handleKeyDown);
      inputEl.onchange = null;
      inputEl.onclick = null;
    };

    // 处理窗口重新获得焦点（可能表示用户取消了文件选择）
    const handleWindowFocus = () => {
      if (isResolved) return;

      // 延迟检查，给onchange事件一些时间触发
      cancelTimer = setTimeout(() => {
        if (!isResolved) {
          // 检查是否真的没有选择文件
          const hasFiles = inputEl.files && inputEl.files.length > 0;
          if (!hasFiles) {
            console.log('123 File selection cancelled by user (focus event)');
            isResolved = true;
            cleanup();
            resolve([]); // 返回空数组表示用户取消了选择
          }
        }
      }, 300); // 300ms延迟，确保onchange有足够时间触发
    };

    // 处理键盘事件（ESC键取消）
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !isResolved) {
        console.log('File selection cancelled by ESC key');
        isResolved = true;
        cleanup();
        resolve([]);
      }
    };

    // 处理文件选择
    inputEl.onchange = function () {
      if (isResolved) return;

      // @ts-ignore
      let { files } = this;
      isResolved = true;
      cleanup();

      if (files.length === 0) {
        console.log('123 No files selected');
        resolve([]);
        return;
      }

      files = slice.call(files, 0, count);
      Promise.all(files.map((file) => lrz(file, {
        width: maxWidth,
        height: maxHeight,
        quality,
      }))).then((newFiles) => {
        // @ts-ignore
        newFiles.forEach((file) => file.from = 'h5');
        console.log(`123 Successfully processed ${newFiles.length} images`);
        resolve(newFiles);
      }, (error) => {
        console.error('123 Image processing failed:', error);
        reject(error);
      });
    };

    // 监听窗口焦点事件来检测取消操作
    window.addEventListener('focus', handleWindowFocus);
    // 监听键盘事件
    document.addEventListener('keydown', handleKeyDown);

    inputEl.onclick = function (e) {
      e.stopPropagation();
    };

    // 设置超时处理，防止某些情况下Promise永远不resolve
    timeoutTimer = setTimeout(() => {
      if (!isResolved) {
        console.log('123 File selection timeout, treating as cancelled');
        isResolved = true;
        cleanup();
        resolve([]);
      }
    }, 30000); // 30秒超时

    try {
      inputEl.click();
    } catch (error) {
      console.error('123 Failed to trigger file selection:', error);
      isResolved = true;
      cleanup();
      reject(error);
    }
  });
}

export default chooseImage;
